import { createSelectionListViewComponent } from 'factories/SelectionListView'
import { getSessionItem, updateSessionItem } from 'helpers/sessionStorage'
import { getStorageKey } from '.'

export default createSelectionListViewComponent({
  pageTitleLanguageKey: 'supervisor',
  getItemSize: () => 45,
  allowSearch: () => true,
  getIdField: () => 'userName',
  getValue: () => getSessionItem(getStorageKey(), {}).item?.supervisor || '',
  getOnChange: (self) => (each) =>
    updateSessionItem(getStorageKey(), {}, (draft) => {
      draft.item.supervisor = each.userName
      draft.item.supervisorName = each.fullname
    }),
})()
